<template>
    <div class="middle-box">
        <div class="modal-content">

            <div class="modal-body">
                <div class="modal-header2" >
                    <h4 class="modal-title" id="myModalLabel">Buy XRP</h4>
                    <button type="button" class="close" @click="closeBuyXRP"><span aria-hidden="true">&times;</span></button>
                </div>
                <div class="modal-body" >
                    <div class="row pop-new">
                        <div class="col-lg-5">
                            <p class="i-p">Buy XRP Amount</p>
                            <input type="number" name="buy_amount" id="buy_amount" class="form-control" pattern="[0-9]+" min="0" v-model="buy_amount"
                                   @input="buyAmountChangeFunc($event)">
                        </div>
                        <div class="col-lg-5">
                            <p class="i-p">Transfer Money</p>
                            <input type="text" name="transfer_money" id="transfer_money" class="form-control" readonly v-model="transfer_money">
                        </div>
                        <div class="col-lg-2">
                            <p class="i-p">Currency</p>
                            <select name="currency" id="currency" class="custom-select" @change="buyAmountChangeFunc($event)" v-model="selectCurrency">
                                <!--<option value="USDT">USD</option>-->
                                <option value="KRW" selected>KRW</option>
                            </select>
                        </div>
                    </div>

                    <div class="row pop-new">
                        <p class="d-p">There are no additional fees.</p>
                        <p class="d-p" id="quote_rate">Quote Rate : 1XRP ~ {{xrp_usdt}} USD, {{xrp_krw}} KRW</p>
                    </div>

                    <div class="spacer-20"></div>
                    <div class="row pop-new">
                        <div class="col-lg-3">
                            <p class="i-p">Bank</p>
                            <input type="text" class="form-control sm"  readonly  v-model="bank_name">
                        </div>
                        <div class="col-lg-6 col-11">
                            <p class="i-p">Account</p>
                            <input type="text" class="form-control sm"  readonly v-model="account">
                        </div>
                        <div class="col-lg-1 col-1 btn-col">
                            <p class="i-p " >&nbsp;</p>
                            <a href="javascript:void(0);" @click="copyToClipboard" ><img src="/img/common/copy-icon.png" style="width:27px;height:35px;"></a>
                        </div>
                        <div class="col-lg-2 col-12">
                            <p class="i-p">Holder</p>
                            <input type="text"  class="form-control sm"  readonly v-model="holder">
                        </div>
                    </div>

                    <div class="spacer-20"></div>
                    <div class="row pop-new">
                        <p class="i-p">Transfer name <span>(입금자명 : 통장 입금자와 동일인이어야 합니다.)</span></p>
                        <input type="text" value="Jame, Lee" class="form-control sm"  v-model="transfer_name">
                    </div>
                    <div class="row pop-new">
                        <p class="d-p sm-fnt">입금자명을 정확히 입력 부탁드립니다.<br/>
                            오류 작성 시 입금 확인이 되지 않아 XRP가 이체되지 않을 수 있습니다. </p>
                        <div class="spacer-10"></div>
                        <p class="d-p sm-fnt">Please enter the name of the depositor accurately.<br/>XRP may not be transferred because the deposit cannot be confirmed when writing an error.</p>
                    </div>

                    <div class="spacer-20"></div>
                    <div class="row pop-new">
                        <div class="col-lg-12">
                            <p class="i-p">Receiving Your Wallet</p>
                            <input type="text" value="" class="form-control  sm"  v-model="wallet_address">
                        </div>
                    </div>

                    <div class="spacer-20"></div>
                    <div class="row pop-new">
                        <p class="i-p">Destination Tag(Optional)</p>
                        <input type="text" value="" class="form-control sm"  v-model="destination_tag">
                    </div>

                    <div class="row pop-new">
                        <p class="d-p sm-fnt">Wallet 주소 및 Destination Tag를 정확히 입력 부탁드립니다.<br/>오류 작성 시 잘못 이체된  XRP는 본인 책임으로 보상해드리지 않습니다.<br/>Destination Tag가 없는 경우 칸을 비워주세요.</p>
                        <div class="spacer-10"></div>
                        <p class="d-p sm-fnt">Please enter your Wallet address and Destination Tag correctly.<br/>
                            In case of writing error, XRP transferred incorrectly will not be compensated at your own risk.<br/>
                            If there is no Destination Tag, please leave the field blank.
                        </p>
                    </div>

                    <div class="spacer-20"></div>
                    <div class="row pop-new">
                        <div class="m-btn" >
                            <button v-on:click="confirmBuyXrp" :disabled="isLoading === true">
                                <b-spinner small type="grow" v-if="isLoading"></b-spinner> Submit
                            </button>
                        </div>
                    </div>

                    <div class="spacer-20"></div>
                    <div class="row pop-new">
                        <div class="col-lg-12">
                            <p class="d-p sm-fnt">★ 업무시간 외에 신청된 내용은 영업일 업무 시간 내에 처리됩니다.</p>
                            <p class="d-p sm-fnt">★★ 업무시간: 공휴일을 제외한 월~금요일 오전 9시~ 오후 6시 까지   (기준: GMT+9)</p>
                        </div>
                        <div class="col-lg-12">
                            <p class="d-p sm-fnt">★ Requests made outside of business hours will be processed within business hours.</p>
                            <p class="d-p sm-fnt">★★ Business Hours : Mondays to Fridays except public holidays from 9 a.m. to 6 p.m  (GMT+9)</p>
                        </div>
                    </div>
                    <div class="spacer-20 pc-mode"></div>

                    <div class="row pop-new mb-mode">
                        <div class="modal-footer">
                            <a class="btn btn-default" @click="closeBuyXRP" >닫기</a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "../service/axios";
    import {mapGetters} from "vuex";

    export default {
        name: "BuyXRP",
        data: () =>{
            return {
                isLoading: false,
                transfer_name: "",
                wallet_address: "",
                destination_tag: "",
                bank: {},
                bank_name: "",
                account: "",
                holder: "",
                transfer_money: 0,
                buy_amount: 0,
                xrp_usdt: 0.0,
                xrp_krw: 0.0,
                quote_rate: 0.0,
                selectCurrency: "KRW",
            }
        },
        mounted() {
            this.openBuyXRP();
        },
        computed: {
            ...mapGetters(["isAuthenticated"]), /* store에 저장된 값을 가져온다. */
            ...mapGetters(["detail"]),  /* store에 저장된 값을 가져온다. */
            ...mapGetters(["user"]), /* store에 저장된 값을 가져온다. */
        },
        methods: {
            openBuyXRP() {
                if (this.isAuthenticated) {
                    // JWT-Token Expired check
                    axios
                        .post("/auth/v1/verifyToken")
                        .then(response => {

                        })
                        .catch(error => {
                            console.log(error)
                        });

                    axios
                        .post("/xrp/v1/buyinfo")
                        .then(response => {
                            if (response.status === 200) {
                                if (response.data.status === 'f') {
                                    this.$swal.fire({ icon: 'warning', title: response.data.message })
                                } else {
                                    this.wallet_address =  this.detail.xrp_wallet;
                                    this.destination_tag = '';
                                    this.selectCurrency = 'KRW';
                                    this.buy_amount = 0;
                                    this.transfer_name = '';
                                    this.transfer_money = 0;
                                    const rate = response.data.rate;
                                    this.xrp_usdt = rate.usdt;
                                    this.xrp_krw = rate.krw;
                                    this.quote_rate = rate.company_fee;
                                    this.bank = response.data.bank;

                                    this.bank_name = this.bank.krw_bank_name;
                                    this.account = this.bank.krw_account;
                                    this.holder = this.bank.krw_holder;
                                }
                            }
                            this.isLoading = false;
                        })
                        .catch(error => {
                            console.log(error)
                            this.isLoading = false;
                        });
                } else {
                    this.$swal.fire({ icon: 'warning', title: 'You need to login!' })
                }
            },
            confirmBuyXrp() {
                if (!this.buy_amount || this.buy_amount === 0) {
                    this.$swal.fire({ icon: 'warning', title: 'Buy XRP Amount is required.' })
                    return;
                }
                if (!this.transfer_name) {
                    this.$swal.fire({ icon: 'warning', title: 'Transfer name is required.' })
                    return;
                }
                if (!this.wallet_address) {
                    this.$swal.fire({ icon: 'warning', title: 'Receiving Wallet address is required.' })
                    return;
                }
                if (this.isLoading) {
                    return;
                }
                this.$swal.fire({
                    title: 'Confirmation',
                    text: "Would you like to proceed with the purchase application?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ok',
                    cancelButtonText: 'Cancel' }).then((result) => {
                    if (result.isConfirmed) {
                        this.submitRequest();
                    }
                });
            },
            submitRequest() {
                let data = {
                    buy_amount: this.buy_amount,
                    transfer_money: this.transfer_money,
                    transfer_name: this.transfer_name,
                    receive_wallet: this.wallet_address,
                    destination_tag: this.destination_tag,
                    currency: this.selectCurrency,
                    quote_rate: this.quote_rate,
                    bank_name: this.bank_name,
                    account: this.account,
                    holder: this.holder,
                }
                axios
                    .post("/auth/v1/verifyToken")
                    .then(response => {

                    })
                    .catch(error => {
                        console.log(error)
                    });
                axios
                    .post("/xrp/v1/buyreq", data)
                    .then(response => {
                        if (response.status === 200) {
                            if (response.data.status === 's') {
                                this.$swal.fire({ icon: 'success', title: 'Your application has been completed.' }).then((result) => {
                                    this.closeBuyXRP();
                                });
                            } else {
                                this.$swal.fire({ icon: 'warning', title: 'The application failed. Please contact site administrator.' });
                            }
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            closeBuyXRP() {
                this.$router.go (-1);
            },
            buyAmountChangeFunc(event){
                let amount = 0;
                if (this.selectCurrency === 'KRW') {
                    amount = this.buy_amount * this.xrp_krw;
                    this.bank_name = this.bank.krw_bank_name;
                    this.account = this.bank.krw_account;
                    this.holder = this.bank.krw_holder;
                } else {
                    amount = this.buy_amount * this.xrp_usdt;
                    this.bank_name = this.bank.usdt_bank_name;
                    this.account = this.bank.usdt_account;
                    this.holder = this.bank.usdt_holder;
                }
                this.transfer_money = this.comma(amount);
            },
            copyToClipboard : function () {
                const t = document.createElement("textarea");
                document.body.appendChild(t);
                t.value = this.account + " " + this.bank_name;
                t.select();
                document.execCommand('copy');
                document.body.removeChild(t);
                const Toast = this.$swal.mixin({
                    toast: true,
                    position: 'center-center',
                    showConfirmButton: false,
                    timer: 1500,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', this.$swal.stopTimer)
                        toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                    }
                })
                Toast.fire({ icon: 'success', title: 'The bank account number has been copied.' })
            },
            comma(val){
                return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
        },
    }
</script>

<style scoped>
    .middle-box {
        max-width: 800px;
        width: 90%;
        text-align: center;
        padding: 30px 0 0 0;
        position: relative;
        margin: 0 auto;
    }
    .middle-box .modal-content {
        border-radius: 0;
        background-color: #e2e4e8;
        border: 0px solid #6aa7ff;

    }
    .middle-box > .modal-content > .modal-body {
        padding: 0px 0px 0px 0px !important;
    }
    .middle-box .modal-header2 {
        height: 50px;
        padding: 14px;
        position: relative;
        text-align: center;
        border-top-left-radius: 0.0rem;
        border-top-right-radius: 0.0rem;
        background-color: #3674bd;
        color: #fff;
        min-height: 16.43px;
        padding: 15px;
        border-bottom: 1px solid #e5e5e5;
    }

    .middle-box .modal-title {
        color: #fff;
        font-size: 18px;
        margin: 0;
    }
    .modal-header2 .close {
        width: 40px;
        height: 40px;
        position: absolute;
        top: 0;
        right: 0;
        color: #fff;
        opacity: 0.5;
        background-image: url(/assets/images/common/delete-white.svg);
        background-repeat: no-repeat;
        background-size: 12px 12px;
        background-position: center center;
    }
    .modal-header2 .close .span {
        color: #f8f9fa;
        font-size : 1.5rem;
    }
    .middle-box .modal-header2 button {
        margin: 7px 3px 0 0;
    }
</style>